import { render } from "./TraceabilityDetail.vue?vue&type=template&id=43bd4d19&scoped=true"
import script from "./TraceabilityDetail.vue?vue&type=script&lang=js"
export * from "./TraceabilityDetail.vue?vue&type=script&lang=js"

import "./TraceabilityDetail.vue?vue&type=style&index=0&id=43bd4d19&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bd4d19"]])

export default __exports__